module.exports = __webpack_public_path__ + "img/version_img2.9f6e17c2.png";